import { Component, Input } from '@angular/core';
import { ApproveCommandCallback, OrderPhaseFooterCommandBase } from '@app/shared/components';

@Component({
  selector: 'app-order-phase-footer',
  templateUrl: './order-phase-footer.component.html',
  styleUrls: ['./order-phase-footer.component.scss']
})
export class OrderPhaseFooterComponent {
  @Input() public cancelCommand: OrderPhaseFooterCommandBase;
  @Input() public backCommand: OrderPhaseFooterCommandBase;
  @Input() public nextCommand: OrderPhaseFooterCommandBase;
  @Input() public confirmFirstCheckboxCommand: OrderPhaseFooterCommandBase;
  @Input() public confirmSecondCheckboxCommand: OrderPhaseFooterCommandBase;

  constructor() {}

  public onCancelClick(): void {
    this.executeCommand(this.cancelCommand, true);
  }

  public onBackClick(): void {
    this.executeCommand(this.backCommand, true);
  }

  public onNextClick(): void {
    this.executeApproveCommand(this.nextCommand, true);
  }

  public onFirstCheckboxChange(): void {
    this.executeCommand(this.confirmFirstCheckboxCommand, false);
  }

  public onSecondCheckboxChange(): void {
    this.executeCommand(this.confirmSecondCheckboxCommand, false);
  }

  private executeCommand(command: OrderPhaseFooterCommandBase, isButton: boolean): void {
    if (isButton && !command.enabled) {
      return;
    }
    command.execute();
  }

  private executeApproveCommand(command: OrderPhaseFooterCommandBase, isButton: boolean): void {
    if (isButton && !command.enabled) {
      return;
    }
    command.commandCallback = this.uncheckCheckbox(this.confirmFirstCheckboxCommand, this.nextCommand);
    command.execute();
  }

  private uncheckCheckbox(footerCommand: OrderPhaseFooterCommandBase, nextCommand: OrderPhaseFooterCommandBase): ApproveCommandCallback {
    return (flag) => {
      if (flag) {
        footerCommand.enabled = nextCommand.enabled = false;
        footerCommand.required = true;
      }
    };
  }
}
